import { render, staticRenderFns } from "./TaskNameColumn.vue?vue&type=template&id=55f5fb62&v-slot=props&"
import script from "./TaskNameColumn.vue?vue&type=script&lang=js&"
export * from "./TaskNameColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports